import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";
import { money, GENDER_PREF } from "@/data/constants";
import { MapPin, Users, GraduationCap, Lock, ShieldCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const FALLBACK =
  "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?crop=entropy&cs=srgb&fm=jpg&q=85&w=940";

export const RoommateCard = ({ post, index = 0 }) => {
  const cover = post.photos?.length ? fileUrl(post.photos[0]) : FALLBACK;
  const gender = GENDER_PREF.find((g) => g.value === post.gender_pref);

  return (
    <Link
      to={`/roommate/${post.id}`}
      data-testid={`roommate-card-${post.id}`}
      className="group rento-fade-up block overflow-hidden rounded-2xl border border-border/60 bg-white transition-shadow duration-300 hover:shadow-[0_18px_50px_-20px_rgba(44,56,48,0.35)]"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-[#EDE9E1]">
        <img src={cover} alt={post.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" onError={(e) => { e.currentTarget.src = FALLBACK; }} />
        <Badge className="absolute left-3 top-3 rounded-full border-0 bg-[#D4A373] text-white">{post.post_type === "seeking" ? "Looking for a room" : "Roommate wanted"}</Badge>
        {post.owner_verified && (
          <Badge data-testid="verified-badge" className="absolute right-3 bottom-3 rounded-full border-0 bg-[#1D4ED8] text-white"><ShieldCheck className="mr-1 h-3 w-3" /> Verified</Badge>
        )}
        {post.spots_available != null && (
          <span className="absolute right-3 top-3 rounded-full bg-black/50 px-2.5 py-1 text-xs font-medium text-white backdrop-blur">
            {post.spots_available} spot{post.spots_available === 1 ? "" : "s"}
          </span>
        )}
      </div>
      <div className="space-y-3 p-5">
        <h3 className="font-display text-lg font-medium leading-snug text-[#1A1A1A] line-clamp-1">{post.title}</h3>
        {post.institution && (
          <div className="flex items-center gap-1.5 text-sm text-[#6B7280]">
            <GraduationCap className="h-4 w-4 shrink-0 text-[#D4A373]" /> <span className="line-clamp-1">{post.institution}</span>
          </div>
        )}
        <div className="flex items-center gap-1.5 text-sm text-[#6B7280]">
          <MapPin className="h-4 w-4 shrink-0 text-[#D4A373]" /> {post.estate ? `${post.estate}, ` : ""}{post.town}, {post.county}
        </div>
        <div className="flex flex-wrap items-center gap-2 text-xs text-[#6B7280]">
          {post.current_roommates != null && (
            <span className="flex items-center gap-1 rounded-full bg-[#F7F5F0] px-3 py-1"><Users className="h-3 w-3" /> {post.current_roommates} current</span>
          )}
          {gender && <span className="rounded-full bg-[#F7F5F0] px-3 py-1">{gender.label}</span>}
        </div>
        <div className="flex items-end justify-between border-t border-border/60 pt-3">
          <div>
            <span className="font-display text-xl font-semibold text-[#2C3830]">{money(post.rent_share, post.currency)}</span>
            <span className="text-sm text-[#6B7280]">{post.post_type === "seeking" ? " budget" : "/mo share"}</span>
          </div>
          <span className="flex items-center gap-1 text-xs font-medium text-[#D4A373]"><Lock className="h-3 w-3" /> Contact locked</span>
        </div>
      </div>
    </Link>
  );
};
